import { useRef, useState } from "react";
import PinScreen from "./components/pin-screen/PinScreen";
import { LiveAPIProvider, useLiveAPIContext } from "./contexts/LiveAPIContext";
import { Altair } from "./components/altair/Altair";
import ControlTray from "./components/control-tray/ControlTray";
import cn from "classnames";
import CenterAudioPulse from "./components/center-audio-pulse/CenterAudioPulse";
// import SidePanel from "./components/side-panel/SidePanel";

const API_KEY = process.env.REACT_APP_GEMINI_API_KEY;
if (typeof API_KEY !== "string") {
  throw new Error("set REACT_APP_GEMINI_API_KEY in .env");
}

const host = "generativelanguage.googleapis.com";
const uri = `wss://${host}/ws/google.ai.generativelanguage.v1alpha.GenerativeService.BidiGenerateContent`;

function AppContent() {
  const videoRef = useRef(null);
  const [videoStream, setVideoStream] = useState(null);
  const { volume, connected } = useLiveAPIContext();

  return (
    <div className="font-space-mono">
      <div className="bg-black text-gray-200 flex h-[100svh] w-screen">
        {/* <SidePanel /> */}
        {/* do not uncomment the side panel. it is used for debugging and development purposes only */}
        <main className="relative flex flex-col items-center justify-center flex-grow gap-4 max-w-full overflow-hidden">
          <div className="flex flex-1 items-center justify-center">
            <CenterAudioPulse
              volume={volume}
              active={connected}
              videoActive={!!videoStream}
            />
            <Altair />
            <video
              className={cn("flex-grow max-w-[90%] rounded-3xl max-h-fit", {
                hidden: !videoRef.current || !videoStream,
              })}
              ref={videoRef}
              autoPlay
              playsInline
            />
          </div>

          <ControlTray
            videoRef={videoRef}
            supportsVideo={true}
            onVideoStreamChange={setVideoStream}
          >
            {/* put your own buttons here */}
          </ControlTray>
        </main>
      </div>
    </div>
  );
}

function App() {
  const [isPinVerified, setIsPinVerified] = useState(() => {
    const stored = localStorage.getItem("pinAuth");
    if (stored) {
      const { timestamp } = JSON.parse(stored);
      const isValid = Date.now() - timestamp < 1 * 60 * 60 * 1000;
      return isValid;
    }
    return false;
  });

  const handlePinSuccess = () => {
    const authData = { timestamp: Date.now() };
    localStorage.setItem("pinAuth", JSON.stringify(authData));
    setIsPinVerified(true);
  };

  return (
    <LiveAPIProvider url={uri} apiKey={API_KEY}>
      {!isPinVerified ? (
        <PinScreen onSuccess={handlePinSuccess} />
      ) : (
        <AppContent />
      )}
    </LiveAPIProvider>
  );
}

export default App;
